import { render, staticRenderFns } from "./CdbCustomerSummary.vue?vue&type=template&id=044a5eb3&scoped=true&"
import script from "./CdbCustomerSummary.vue?vue&type=script&lang=js&"
export * from "./CdbCustomerSummary.vue?vue&type=script&lang=js&"
import style0 from "./CdbCustomerSummary.vue?vue&type=style&index=0&id=044a5eb3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044a5eb3",
  null
  
)

export default component.exports